

export const CLIENT_FIELDS = ['id', 'firstName', 'lastName', 'middleName', 'phoneNumber', 'additionalPhoneNumber', 'iin', 'oneCId', 'dateOfBirth', 'email', 'gender', 'language'];

export const CONTACT_TYPES = [
  {
    code: 'VISIT',
    label: 'Визит',
  },
  {
    code: 'INCOMING_CALL',
    label: 'Входящий звонок',
  },
  {
    code: 'OUTGOING_CALL',
    label: 'Исходящий звонок',
  },
];

export const CLIENT_TITLE = {
  iin: 'ИИН',
  oneCId: 'Номер в 1С',
  firstName: 'Имя',
  lastName: 'Фамилия',
  middleName: 'Отчество',
  fullName: 'ФИО',
  dateOfBirth: 'Дата рождения',
  gender: 'Пол',
  language: 'Язык',
  phoneNumber: 'Телефон',
  additionalPhoneNumber: 'Доп. телефон',
  email: 'Email адрес',
  countryOfResidence: 'Страна резидента',
  region: 'Регион',
  address: 'Адрес',
  receiveAds: 'Получаeт рекламу',
  documents: 'Паспортные данные',
  bankAccounts: 'Банковский счет',
};


export const GENDERS = [
  { code: 'F', title: 'Женский' },
  { code: 'M', title: 'Мужской' },
];

export const LANGUAGES = [
  { code: 'KK', title: 'Казахский' },
  { code: 'RU', title: 'Русский' },
];

export const GENDERS_SEO = [
  { code: 'F', title: 'Женщина' },
  { code: 'M', title: 'Мужчина' },
];

export const PHONE_MASK = '8 (999) 999-99-99';
